import { useState } from "react";
import { Box, Button, Paper, TextField, Typography, Alert, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { requestPasswordReset } from "../Services/authService";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const data = await requestPasswordReset(email);
      setSuccess(
        data?.message ||
          "Si un compte existe pour cet email, un lien de réinitialisation a été envoyé."
      );
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        "Impossible d'envoyer la demande. Veuillez réessayer.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", p: 2 }}>
      <Paper sx={{ p: 4, width: 400 }}>
        <Typography variant="h6" gutterBottom>Mot de passe oublié</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Saisissez l'email associé à votre compte. Nous vous enverrons un lien
          pour réinitialiser votre mot de passe.
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            required
            disabled={loading || Boolean(success)}
          />
          {error && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mt: 1 }}>
              {success}
            </Alert>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            disabled={loading || Boolean(success)}
          >
            {loading ? "Envoi en cours..." : "Envoyer le lien"}
          </Button>
        </form>
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <MuiLink component={RouterLink} to="/login" variant="body2">
            Retour à la connexion
          </MuiLink>
        </Box>
      </Paper>
    </Box>
  );
}
